import { render } from "./TextFormatEditor.vue?vue&type=template&id=3c473449&scoped=true&ts=true"
import script from "./TextFormatEditor.vue?vue&type=script&lang=ts"
export * from "./TextFormatEditor.vue?vue&type=script&lang=ts"

import "./TextFormatEditor.vue?vue&type=style&index=0&id=3c473449&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c473449"]])

export default __exports__